import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';
import getCurrency from '../../../helpers/getCurrency';
import Colors from '../../../styles/colors';

class SoundcastInCart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      enterPromoCode: false,
      promoApplied: false,
      promoCode: '',
      price: props.initialPrice,
    };

    this.handlePromoCode = this.handlePromoCode.bind(this);
    this.applyPromoCode = this.applyPromoCode.bind(this);
  }

  componentDidMount() {
    const { coupon: promoCode = '' } = this.props;
    if (!isEmpty(promoCode)) {
      this.setState({
        enterPromoCode: true,
        promoCode,
      }, this.applyPromoCode);
    }
  }

  handlePromoCode(e) {
    this.setState({
      promoCode: e.target.value,
      promoCodeError: '',
    });
  }

  applyPromoCode() {
    this.setState({
      promoCodeInfo: '',
      promoCodeError: '',
    }, async () => {
      try {
        const { promoCode } = this.state;
        const { promoCodeInfo } = await this.props.onAppliedPromo(promoCode);
        this.setState({
          promoCodeInfo,
          promoApplied: true,
        });
      } catch(err) {
        const { message } = err || {};
        const promoCodeError = message || 'Unknown error';
        this.setState({
          promoApplied: false,
          promoCodeError,
        });
      }
    });
  }

  renderPromoInput() {
    const {
      price,
      enterPromoCode,
      promoCode,
      promoApplied,
      promoCodeInfo,
      promoCodeError,
    } = this.state;

    if (!enterPromoCode) {
      return (
        <button
          className="coupon-btn text-medium font-weight-700"
          onClick={() => {
            this.setState({
              enterPromoCode: true,
            }, () => {
              this.refs.promoCodeInput.focus();
            });
          }}
        >
          Apply Promo
        </button>
      );
    }

    if (promoApplied) {
      return (
        <div className="coupon-info text-large">{promoCodeInfo}</div>
      );
    }

    return (
      <div>
        {!promoApplied && (
          <React.Fragment>
            <div style={{ display: 'flex' }}>
              <input
                onChange={this.handlePromoCode}
                className="coupon-input border-radius-4"
                size="20"
                type="text"
                name="promo"
                ref="promoCodeInput"
                placeholder="Enter promo code"
                value={promoCode || ''}
              />
              <button
                type="button"
                className="btn"
                onClick={this.applyPromoCode}
              >
                Apply
              </button>
            </div>
            <div className="coupon-error">{promoCodeError}</div>
          </React.Fragment>
        )}
      </div>
    );
  }

  render() {
    const { soundcast, checked, successPayment, isFree = false, isTrial = false } = this.props;
    const { price } = this.state;
    if (soundcast && successPayment) {
      return (
        // show only cover image and title
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <OrderDetails>
              <img className="soundcast-image border-radius-4" src={soundcast.imageURL} alt="image" />
              <div className="soundcast-info align-center">
                <div className="soundcast-title font-weight-700">{soundcast.title}</div>
              </div>
            </OrderDetails>
          </div>
        </div>
      );
    }

    const pricing = soundcast.prices[checked || 0];
    const currency = getCurrency(pricing);
    const actualPrice = isFree && !isTrial ? 0 : price;
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <OrderDetails>
              <img className="soundcast-image border-radius-4" src={soundcast.imageURL} alt="image" />
              <div className="soundcast-info">
                <div className="soundcast-title font-weight-700">{soundcast.title}</div>
                <div>
                  {pricing.paymentPlan}
                </div>
              </div>
            </OrderDetails>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <PricingDetails>
              <div className="pricing-row">
                <div className="text-medium">Price</div>
                <div className="text-large font-weight-700">
                  {`${currency} ${Number(actualPrice).toFixed(2)}`}
                </div>
              </div>
              <div className="pricing-row">
                <div className="text-medium">Processing Fee</div>
                <div className="text-large font-weight-700">
                  {`${currency} 0.00`}
                </div>
              </div>
              {(!isFree || isTrial) && (
                <div className="pricing-row">
                  <div className="text-medium">Promo Code</div>
                  {this.renderPromoInput()}
                </div>
              )}
            </PricingDetails>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const OrderDetails = styled.div`
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
  /* border-bottom: 2px dashed #eee; */
  padding-bottom: 10px;

  .soundcast-image {
    width: 46px;
    height: 46px;
    margin-right: 15px;
  }

  .soundcast-info {
    display: flex;
    flex-direction: column;

    .soundcast-title {
      font-size: 1.7rem;
      display: block;
      line-height: 20px;
      margin-bottom: 3px;
      width: 100%;
      color: ${Colors.fontBlack};
    }

    &.align-center {
      align-self: center;
    }
  }
`;

const PricingDetails = styled.div`
  padding: 10px 0;

  .pricing-row {
    display: flex;
    justify-content: space-between;
    padding: 2px 0;

    .coupon-btn {
      color: #00BCD4;
      background: none;
      border: none;
      padding: 0;
    }

    .coupon-input {
      margin: 0px;
      font-size: 1.4rem;
      padding: 0 5px;
      margin-right: 5px;
    }

    .coupon-info {
      color: #f76b1d;
      font-style: italic;
      text-align: right;
    }

    .coupon-error {
      color: #f44336;
      text-align: right;
    }
  }
`;

SoundcastInCart.propTypes = {
  soundcast: PropTypes.object,
  coupon: PropTypes.string,
  initialPrice: PropTypes.string,
  checked: PropTypes.number,
  onAppliedPromo: PropTypes.func,
  successPayment: PropTypes.bool,
  isFree: PropTypes.bool,
  isTrial: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
};

SoundcastInCart.defaultProps = {
  soundcast: {},
  coupon: '',
  initialPrice: '',
  checked: 0,
  onAppliedPromo: () => {},
  successPayment: false,
  isFree: false,
  isTrial: false,
};

export default SoundcastInCart;
